export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/loader_zp_100x100.edd00f0c.gif";